export default "__VITE_ASSET__Bwj8LaRQ__"